import { ref, readonly } from '@vue/composition-api';
import ethicApi from '../../../api/ethics-api';
import { FORM_STATES } from '../constants';

export const useInit = (state) => {
	const subsidiaries = ref({});
	const init = async () => {
		try {
			state.value = FORM_STATES.LOADING;
			const { data } = await ethicApi.init();
			subsidiaries.value = data;
			state.value = FORM_STATES.FORM;
		} catch (error) {
			state.value = FORM_STATES.ERROR;
		}
	};
	return { init, subsidiaries: readonly(subsidiaries) };
};
